import { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';

// redux
import { setEndDate as SliceSetEndDate, setStartDate as SliceSetStartDate } from '_redux/slices/beacons/beacons';
import { setUser } from '_redux/slices/profile/user-profile';
import { useDispatch } from 'react-redux';

// custom components
import { Card, Container, ListSelector } from "_atoms";

// bootstrap
import Row from 'react-bootstrap/Row';

// tremor
import {
    Bold,
    DateRangePicker,
    Flex,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableHeaderCell,
    TableRow,
    Text,
    Title as TremorTitle
} from '@tremor/react';

// styling 
import { Colors } from '_styles';

// icons
import { GrBeacon } from "react-icons/gr";

// format time stamp
function formatTimestamp(dateString) {
    const date = new Date(dateString);

    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const hours = date.getHours();
    const minutes = String(date.getMinutes()).padStart(2, '0');
  
    let formattedTime = hours >= 12 ? 'pm' : 'am';
    let displayHours = hours % 12;
    displayHours = displayHours === 0 ? 12 : displayHours;
    const timeString = `${displayHours}:${minutes}${formattedTime}`;
  
    return `${year}-${month}-${day} - ${timeString}`;
}

function getDateOneWeekAgo(currentDate) {
    // Get the current timestamp
    const currentTimestamp = currentDate.getTime();
    
    // Calculate the timestamp for 7 days ago (7 * 24 * 60 * 60 * 1000 milliseconds)
    const sevenDaysAgoTimestamp = currentTimestamp - 604800000;
    
    // Create a new date object from the timestamp for 7 days ago
    const sevenDaysAgo = new Date(sevenDaysAgoTimestamp);
    
    return sevenDaysAgo;
}


const WaitingTimesTable = (props) => {

    // nav
    const history = useHistory();

    // rdux
    const dispatch = useDispatch();

    const showProfile = (userId) => { 
        if(userId != undefined && userId != null && userId != ''){
            dispatch(setUser(userId))
            history.push('/user-profile')
        }
    }

    const headers = ['Beacon ID', 'Elasped Time (Formatted)', 'User ID', 'Timestamp']

    const currentDate = new Date()
    const [startDate, setStartDate] = useState(null)
    const [endDate, setEndDate] = useState(null)
    const [date, setDate] = useState([ getDateOneWeekAgo(currentDate), new Date()]);

    useEffect(() => {
        // single day
        if(date[1] == null){
            setStartDate(date[0].toISOString().split('T')[0]);
            setEndDate(date[0].toISOString().split('T')[0])
        }
        // set two day date range
        else if(date[1] != null){
            setStartDate(date[0].toISOString().split('T')[0]);
            setEndDate(date[1].toISOString().split('T')[0])
        }
    }, [date]);

    useEffect(() => {
        if(startDate != null){
            dispatch(SliceSetStartDate(startDate));
        }
    }, [startDate]);

    useEffect(() => {
        if(endDate != null){
            dispatch(SliceSetEndDate(endDate));
        }
    }, [endDate]);

    return (
        <Container>

            <Row>
                <Flex>
                    <ListSelector icon={<GrBeacon />} />
                    <DateRangePicker 
                        onValueChange={(value)=>{ setDate(value)}}
                        value={date} 
                        enableDropdown={true} 
                        maxWidth="max-w-lg" 
                        dropdownPlaceholder={'Last 7 Days'}
                    />
                </Flex>
            </Row>

            <Card className='mt-4'>
                <div style={{ overflowY:'scroll', height:'40em', }}>

                <Row>
                    <Flex>
                        <Container>
                            <TremorTitle>{props.title}</TremorTitle>
                            <Text>{props.subtitle}</Text>
                        </Container>
                    </Flex>
                </Row>

                <Table marginTop='mt-2.5'>

                    { props.data != undefined && props.data.length != undefined && props.data.length == 0 ? <p></p> :           
                    <TableHead>
                        <TableRow>
                            { headers.map((value) => (
                                <TableHeaderCell><Text><Bold>{value}</Bold></Text></TableHeaderCell>
                            ))}
                        </TableRow>
                    </TableHead>
                    }
                    
                    { props.data != undefined && props.data.length != undefined && props.data.length == 0 ? <p className='mt-5' style={{ textAlign:'center'}}>No available data</p> : 
                    <TableBody>
                        { props.data != undefined && props.data.map != undefined && props.data.map((waitTime) => (
                            <TableRow>
                                <TableCell><Text truncate={true}>{waitTime.beaconId ? waitTime.beaconId : "N/A"}</Text></TableCell>
                                <TableCell><Text truncate={true}>{waitTime.elapsedTime ? waitTime.elapsedTime : "N/A"}</Text></TableCell>
                                <TableCell><p style={{ color:Colors.PRM_LIGHT_BLUE, fontWeight:'300', cursor:'pointer'}} onClick={()=> {showProfile(waitTime.userId)}} truncate={true}>{waitTime.userId ? waitTime.userId : "N/A"}</p></TableCell>
                                <TableCell><Text truncate={true}>{waitTime.time && formatTimestamp(waitTime.time) ? formatTimestamp(waitTime.time) : "N/A"}</Text></TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                    }
                </Table>
                </div>
            </Card>
        </Container>
    );
};

export default WaitingTimesTable;
